import Button from '@algbra/ui/components/Button/Button'
import Dialog from '@algbra/ui/components/Dialog/Dialog'
import FreeText from '@algbra/ui/components/FreeText/FreeText'
import Heading from '@algbra/ui/components/Heading/Heading'
import { getIconByName } from '@algbra/ui/icons'
import { resolveAsImage } from '@algbra/ui/resolvers'
import classNames from 'classnames'
import { GatsbyImage } from 'gatsby-plugin-image'
import { useState } from 'react'
import { EmbedVideo } from '../../components/EmbedVideo/EmbedVideo'
import { VideoFullScreen } from '../../components/Video/VideoFullscreen'
import { EventEntity } from '../../types/event'
import styles from './MeetupItem.module.scss'

export type MeetupItemProps = {
  event: EventEntity
}

export default function MeetupItemFeatured(props: MeetupItemProps) {
  const { event } = props
  const {
    title,
    summary,
    image,
    link,
    type,
    theme,
    backgroundImage,
    logoImage,
    youtube_code,
  } = event
  const [isDialogVisible, setDialogVisible] = useState<boolean>(false)
  const [isFullscreen, setFullscreen] = useState<boolean>(false)
  const onToggleVideo = () => {
    setFullscreen(!isFullscreen)
  }

  return (
    <div
      className={styles.container}
      itemScope
      itemType="http://schema.org/Event"
    >
      <div
        className={classNames(
          styles.event,
          styles.featured,
          styles[`theme__${theme}`]
        )}
        style={
          backgroundImage && {
            backgroundImage: `url(${backgroundImage.resolved.publicURL})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }
        }
      >
        <div className={styles.content}>
          {logoImage ? (
            <GatsbyImage
              className={styles.logo}
              image={resolveAsImage(logoImage)}
              alt={`Algbra Event: ${title}`}
            />
          ) : (
            <Heading
              level={3}
              type="sm"
              className={styles.title}
              itemProp="name"
            >
              {title}
            </Heading>
          )}
          <FreeText
            color="white"
            innerHTML={summary}
            className={styles.summary}
          >
            {summary}
          </FreeText>
        </div>
        <div className={styles.image}>
          {image && (
            <GatsbyImage
              image={resolveAsImage(image)}
              alt={`Algbra Event: ${title}`}
              itemProp="photo"
            />
          )}
        </div>
        <div className={styles.button}>
          <Button
            type="button"
            theme="light"
            icon={getIconByName('arrow-play')}
            size="small"
            onClick={() => {
              if (youtube_code) {
                onToggleVideo()
              } else {
                setDialogVisible(true)
              }
            }}
            className={styles.reverse}
          >
            Watch AD
          </Button>
        </div>
      </div>
      {youtube_code && isFullscreen ? (
        <VideoFullScreen
          onToggleVideo={onToggleVideo}
          youtube_code={youtube_code}
        />
      ) : (
        <Dialog
          isOpen={isDialogVisible}
          onClose={() => {
            setDialogVisible(false)
            return false
          }}
        >
          {isDialogVisible && <EmbedVideo src={link} autoPlay={true} />}
        </Dialog>
      )}
    </div>
  )
}
